import {Card, CardProps, Box, Typography} from '@mui/material';
import {ReactNode} from 'react';

interface EntioCardProps extends CardProps {
  /** Card title rendered in the header area */
  title?: string;
  /** Optional right-side content in the header (action buttons, badges) */
  headerAction?: ReactNode;
  /** If true, removes body padding */
  flush?: boolean;
}

/**
 * Standard card wrapper with consistent border, radius, and padding.
 *
 * Replaces: all ad-hoc Card + sx={{ border: '1px solid #d9d9d9', borderRadius: 3 }}
 * patterns across Dashboard cards and detail pages.
 *
 * Usage:
 *   <EntioCard title="Device Stats">
 *     <SomeContent />
 *   </EntioCard>
 *
 *   <EntioCard flush>
 *     <DataGrid ... />
 *   </EntioCard>
 */
export default function EntioCard({
  title,
  headerAction,
  flush,
  children,
  sx,
  ...props
}: EntioCardProps) {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      {...props}
    >
      {title && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            pt: 2.5,
            pb: 1.5,
          }}
        >
          <Typography variant="subtitle1">{title}</Typography>
          {headerAction}
        </Box>
      )}
      <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', ...(flush ? {} : {px: 3, pb: 2.5, ...(title ? {} : {pt: 2.5})})}}>
        {children}
      </Box>
    </Card>
  );
}
